var map = {
	"./powered-by-ei.embedded.svg": 536,
	"./powered-by-german_site.embedded.svg": 537,
	"./powered-by-ht_media.embedded.svg": 538
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1271;


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/images ^\.\/powered\-by\-.*\.embedded\.svg$
// module id = 1271
// module chunks = 30